import { DOCUMENT } from '@angular/common';
import {
  ComponentRef,
  createComponent,
  Directive,
  ElementRef,
  EnvironmentInjector,
  HostListener,
  Inject,
} from '@angular/core';
import { EditorService } from '../../services/editor.service';
import { InlineEditIframeComponent } from '../inline-edit-iframe/inline-edit-iframe.component';

@Directive({
  selector: '[appIframeBlock]',
  standalone: true,
})
export class EditableIframeDirective {
  /** aktualnie pokazany toolbar */
  private cmpRef?: ComponentRef<InlineEditIframeComponent>;
  /* … */
  private hideTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private host: ElementRef<HTMLElement>,
    private envInjector: EnvironmentInjector,
    private editorService: EditorService,
    @Inject(DOCUMENT) private doc: Document,
  ) {
  }

  @HostListener('mouseenter') onEnter(ev: MouseEvent) {
    if (!this.editorService.isEditModeEnabled()) {
      return;
    }
    if (this.host.nativeElement.closest('[main-menu]')) {
      return;
    }
    this.clearHideTimer();
    this.showToolbar();
  }

  @HostListener('mouseleave', ['$event'])
  onLeave(ev: MouseEvent) {
    if (
      !this.editorService.isEditModeEnabled() ||
      this.editorService.isBlock(ev)
    ) {
      return;
    }
    this.startHideTimer();
  }

  private attachToolbarListeners(el: HTMLElement) {
    el.addEventListener('pointerenter', () => this.clearHideTimer());
    el.addEventListener('pointerleave', () => this.startHideTimer());
  }

  private startHideTimer() {
    if (this.hideTimer) {
      return;
    }
    this.hideTimer = setTimeout(() => {
      this.destroyToolbar();
      this.hideTimer = null;
    }, 50);
  }

  private clearHideTimer() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }

  /* ─── pomocnicze ─── */
  private showToolbar(): void {
    const pos = this.host.nativeElement.getBoundingClientRect();

    if (this.cmpRef) {
      this.positionToolbar(this.cmpRef.location.nativeElement, pos);
      this.attachToolbarListeners(this.cmpRef.location.nativeElement);
      this.cmpRef.instance.target = this.host.nativeElement;
      return;
    }

    /* ── twórz nową instancję ── */
    this.cmpRef = createComponent(InlineEditIframeComponent, {
      environmentInjector: this.envInjector,
    });

    this.cmpRef.instance.moved.subscribe((evt) => {
      this.handleMove(evt.element, evt.dir);
    });

    const el = this.cmpRef.location.nativeElement as HTMLElement;
    el.setAttribute('data-editor-toolbar', '');
    this.positionToolbar(el, pos);
    this.attachToolbarListeners(el);
    this.cmpRef.instance.target = this.host.nativeElement;
    this.cmpRef.instance.closed.subscribe(() => this.destroyToolbar());

    this.doc.body.appendChild(el);
  }

  private handleMove(el: HTMLElement, dir: string) {
    console.log('Przesunięto blok', el, 'kierunek', dir);
  }

  private positionToolbar(el: HTMLElement, pos: DOMRect): void {
    Object.assign(el.style, {
      position: 'absolute',
      top: `${pos.top + this.doc.defaultView!.scrollY}px`,
      left: `${pos.left + this.doc.defaultView!.scrollX}px`,
      width: `${pos.width}px`,
      height: `${pos.height}px`,
      zIndex: '1000',
    });
  }

  private destroyToolbar(): void {
    if (!this.cmpRef) {
      return;
    }

    /* zapamiętuję węzeł przed destroy() */
    const el = this.cmpRef.location.nativeElement as HTMLElement;

    this.cmpRef.destroy();
    el.remove();

    this.cmpRef = undefined;
  }
}
